import React from "react";
import "./Group278.css";

function Group278(props) {
  const { className } = props;

  return (
    <div className={`group-278 border-1px-black ${className || ""}`}>
      <img className="more-than-2" src="/img/more-than-1@2x.png" />
    </div>
  );
}

export default Group278;
